import Vue from 'vue';
import App from './components/com/App.vue';
Vue.config.productionTip = false;

/**路由*/
import VueRouter from "vue-router";
Vue.use(VueRouter);

/**工具类*/
import tools from './components/module/tools.vue';
Vue.prototype.$tools = tools;

/**工具类*/
import {
	request,
	reqToken
} from './components/module/NetHttp.js';
Vue.prototype.$req = request;
Vue.prototype.$reqToken = reqToken;

/**认证管理*/
import { checkLoginStatus } from './components/module/auth.js';
/**框架*/
import Antd from 'ant-design-vue';
Vue.use(Antd);

//rem 适配  1rem = 10px
import './components/module/fontSize.js';

/**swiper*/
import * as Swiper from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';

import 'animate.css';
import 'fullpage-vue2/src/fullpage.css';
import VueFullpage from 'fullpage-vue2';
Vue.use(VueFullpage);

/**公共css*/
import 'ant-design-vue/dist/antd.css';
import './assets/css/com/lib.css';
import "quill/dist/quill.core.css"

import Main from './page/portal/main.vue';
import Index from './page/portal/content/index.vue';
import Product from './page/portal/content/product.vue';
import Agora from './page/portal/content/agora.vue';
import AgoraDes from './page/portal/content/agoraDes.vue';
import Solution from './page/portal/content/solution.vue';
import New from './page/portal/content/new.vue';
import NewDes from './page/portal/content/newDes.vue';
import pageDes from './page/portal/content/pageDes.vue';
import Contact from './page/portal/content/contact.vue';
import About from './page/portal/content/about.vue';
import Recruit from './page/portal/content/recruit.vue';
import Energy from './page/portal/content/energy.vue';
import Calculate from './page/portal/content/calculate.vue';
import DataAI from './page/portal/content/dataAI.vue';

import Admin from './page/admin/admin.vue';
import Center from './page/admin/content/center.vue';
import Buy from './page/admin/content/buy.vue';
import Order from './page/admin/content/order.vue';
import Bill from './page/admin/content/bill.vue';
import BillReq from './page/admin/content/billReq.vue';
import BillDes from './page/admin/content/billDes.vue';
import BillReissue from './page/admin/content/billReissue.vue';
import Pact from './page/admin/content/pact.vue';
import InviteRecord from './page/admin/content/inviteRecord.vue';

const routes = [{
	path: '/',
	name: 'main',
	component: Main,
	redirect: '/index',
	children: [{
		path: "index",
		component: Index,
	}, {
		path: "product",
		component: Product,
	}, {
		path: "agora",
		component: Agora,
	}, {
		path: "agoraDes",
		component: AgoraDes,
	}, {
		path: "solution",
		component: Solution,
	}, {
		path: "new",
		component: New,
	}, {
		path: "newDes",
		component: NewDes,
	}, {
		path: "pageDes",
		component: pageDes,
	}, {
		path: "contact",
		component: Contact,
	}, {
		path: "about",
		component: About,
	}, {
		path: "recruit",
		component: Recruit,
	}, {
		path: "energy",
		component: Energy,
	}, {
		path: "calculate",
		component: Calculate,
	}, {
		path: "dataAI",
		component: DataAI,
	}]
}, {
	path: '/admin',
	name: 'admin',
	component: Admin,
	redirect: '/admin/center',
	children: [{
		path: "center",
		component: Center,
	}, {
		path: "buy",
		component: Buy,
	}, {
		path: "order",
		component: Order,
	}, {
		path: "bill",
		component: Bill,
	}, {
		path: "billReq",
		component: BillReq,
	}, {
		path: "billDes",
		component: BillDes,
	}, {
		path: "billReissue",
		component: BillReissue,
	}, {
		path: "pact",
		component: Pact,
	}, {
		path: "inviteRecord",
		component: InviteRecord,
	}]
}];

const router = new VueRouter({
	routes,
	mode: "history",
	linkActiveClass: 'active',
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		};
	}
});

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
	// 检查登录状态
	if (checkLoginStatus(to.path)) {
		next();
	} else {
		// 如果检查失败，路由守卫会阻止导航
		// 认证模块会自动处理跳转
		next(false);
	}
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
};

const app = new Vue({
	router,
	render: h => h(App),
}).$mount('#app');

window.app = app;